export function navigateTo(url: string) {
  (window as Window).location = url;
}
